import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./BrandCompatibility.module.scss";

interface Brand {
  name: string;
  logo: string;
  models: string[];
}

const BrandCompatibility: React.FC = () => {
  const { t } = useTranslation("common");

  const brands = t("brandCompatibility.brands", {
    returnObjects: true,
  }) as Brand[];

  return (
    <div className="container section">
      <div className="sectionContainer sectionContainerWhite bigSection">
        <div className="sideP64 sectionTitle">
          <h2 className={styles.title}>{t("brandCompatibility.title")}</h2>
        </div>
        <div className="sectionBlock">
          <div className={styles.grid}>
            {brands.map((brand, i) => (
              <div className={styles.card} key={i}>
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className={styles.logo}
                  loading="lazy"
                />
                <h3 className={styles.brandName}>{brand.name}</h3>
                <div className={styles.models}>
                  {brand.models.map((model, j) => (
                    <p key={j}>{model}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandCompatibility;
